import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  filtersBar: {
    marginBottom: 20,
    padding: '10px 15px',
  },
}));
